import { FileSourceEnum as e, FileTypeEnum as t } from "@systemeio/types";
//#region src/white-label-brand/default-brand-settings.ts
var n = {
	name: "systeme.io",
	colors: { oldBrandPrimary: "#279FE7" },
	favicon: {
		id: 0,
		name: "Favicon",
		filename: "Favicon",
		path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-redesigned.ico",
		thumbnail: null,
		source: e.WhiteLabel,
		size: 0,
		type: t.Image,
		createdAt: ""
	},
	logo: {
		id: 0,
		name: "Logo",
		filename: "Logo",
		path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-redesigned.svg",
		thumbnail: null,
		source: e.WhiteLabel,
		size: 0,
		type: t.Image,
		createdAt: ""
	},
	dashboardHostname: ""
};
//#endregion
export { n as defaultBrandSettings };
